import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-send-result-dialog',
  standalone: true,
  imports: [ButtonModule, CommonModule, TableModule, CardModule],
  template: `
    <div class="flex flex-column gap-3">
      <div class="text-center">
        <i class="pi pi-check-circle text-6xl text-green-500 mb-3"></i>
        <h2 class="m-0">Client sent to Rev.io successfully!</h2>
      </div>

      <p-card header="Summary">
        <div class="grid">
          <div class="col-12 md:col-6">
            <strong>Parent Customer ID:</strong> {{ parentCustomerId || 'N/A' }}
          </div>
          <div class="col-12 md:col-6">
            <strong>Total Customers Created:</strong>
            {{ childCustomers.length }}
          </div>
          <div class="col-12 md:col-6">
            <strong>Total Services Created:</strong> {{ childCustomers.length }}
          </div>
          <div class="col-12 md:col-6">
            <strong>Total Products Created:</strong> {{ totalProducts }}
          </div>
        </div>
      </p-card>

      <p-card header="Child Customers" *ngIf="childCustomers.length > 0">
        <p-table [value]="childCustomers" [paginator]="true" [rows]="5">
          <ng-template pTemplate="header">
            <tr>
              <th>Location Name</th>
              <th>Customer ID</th>
              <th>Service ID</th>
              <th>Products</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-customer>
            <tr>
              <td>{{ customer.locationName }}</td>
              <td>{{ customer.customerId }}</td>
              <td>{{ customer.serviceId }}</td>
              <td>{{ customer.serviceProducts?.length || 0 }}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>

      <div class="flex justify-content-end">
        <p-button
          label="Close"
          icon="pi pi-times"
          (onClick)="close()"
          severity="secondary"
        ></p-button>
      </div>
    </div>
  `,
})
export class SendResultDialogComponent implements OnDestroy {
  parentCustomerId?: number;
  childCustomers: Array<{
    locationName: string;
    customerId: number;
    serviceId: number;
    serviceProducts?: Array<{ serviceProductId: number; productId: number }>;
  }> = [];
  totalProducts = 0;
  private closeSubscription?: Subscription;

  constructor(
    private readonly dialogRef: DynamicDialogRef,
    private readonly dialogConfig: DynamicDialogConfig,
    private readonly router: Router
  ) {
    if (dialogConfig.data) {
      this.parentCustomerId = dialogConfig.data.parentCustomerId;
      this.childCustomers = dialogConfig.data.childCustomers || [];
      this.totalProducts = this.childCustomers.reduce(
        (sum, customer) => sum + (customer.serviceProducts?.length || 0),
        0
      );
    }

    this.closeSubscription = this.dialogRef.onClose.subscribe(() => {
      this.navigateToRecords();
    });
  }

  ngOnDestroy(): void {
    this.closeSubscription?.unsubscribe();
  }

  close() {
    this.dialogRef.close();
  }

  private navigateToRecords(): void {
    this.router.navigate(['/billing/client-onboarding']).then();
  }
}
